'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[GLOBAL ERROR]', error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-[#040a22] text-white">
          <div className="text-center p-8">
            <h2 className="text-2xl font-bold mb-4">Critical Error</h2>
            <p className="text-white/70 mb-4">{error.message}</p>
            <pre className="text-left text-xs bg-black/50 p-4 rounded overflow-auto max-w-md">
              {error.stack}
            </pre>
            <button
              onClick={() => reset()}
              className="mt-4 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg"
            >
              Reload
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
